export default __webpack_public_path__ + "media/images/mailer-new/heading/follow-fe3463c076d97ba5828ee3444a5c9c95.png";